const MEDALLIA_LANGUAGE_MAPPING: Record<string, string> = {
  cz: "CS",
};

const getMedalliaCountryMapping = (opco: string): string => {
  return MEDALLIA_LANGUAGE_MAPPING[opco] || opco.toUpperCase();
};

export default getMedalliaCountryMapping;
